import { LinkBox, LinkOverlay, VStack } from '@chakra-ui/react'
import { CoverImage } from '@!/Store/Common/components/CoverImage'

export const Content = ({ contentId, contentName, imageUrl, gtmClick }) => {
  return (
    <LinkBox w="100px">
      <VStack>
        <CoverImage src={imageUrl} alt={contentName} objectFit="contain" width="100px" />
        <LinkOverlay
          href={`/store/books/${contentId}`}
          lineClamp={1}
          fontSize="sm"
          fontWeight="bold"
          width="100%"
          {...(gtmClick && { 'data-gtm-click': gtmClick })}
        >
          {contentName}
        </LinkOverlay>
      </VStack>
    </LinkBox>
  )
}
